import type { TOC } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { or } from 'ember-truth-helpers';
import SettingsBudgetForecastSettingsIndexPage from 'lumen/components/settings/budget-forecast/settings-index-page';
import type HotelSettingsForecastIndexRoute from 'lumen/routes/hotel/settings/forecast/index';
import type { ModelFrom } from 'lumen/utils/routes';

interface HotelSettingsForecastIndexSignature {
  Args: {
    controller: unknown;
    model: ModelFrom<HotelSettingsForecastIndexRoute>;
  };
}

<template>
  <SettingsBudgetForecastSettingsIndexPage
    @entries={{or @model.entries.last.value (array)}}
    @isLoading={{@model.entries.isRunning}}
    @view="forecast"
  />
</template> satisfies TOC<HotelSettingsForecastIndexSignature>;
